import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";
import useAuthStore from "../../stores/useAuthStore";

// Besked när en länk från ett mail (återställning eller aktivering) inte går att använda,
// eller när användaren är inloggad (signedIn) och måste logga ut först.
// requestNewLinkPath är formuläret där en ny länk begärs. legacyCheck är en gammal aktiveringslänks
// check= (om det var en sådan), som följer med så att formuläret kan fylla i adressen.
function LinkStatusCard({ linkStatus, requestNewLinkPath, legacyCheck }) {
  const intl = useIntl();
  const navigate = useNavigate();
  const signOut = useAuthStore((state) => state.signOut);
  const email = localStorage.getItem("email");

  const headerId =
    {
      expired: "LinkStatus.Header.Invalid",
      signedIn: "LinkStatus.Header.SignedIn",
    }[linkStatus] ?? "LinkStatus.Header.NotChecked";

  const messageId = {
    expired: "Views.UpdatePassword.LinkExpired",
    tooManyRequests: "TooManyRequestsTryLater",
    error: "GenericApiError",
    signedIn: email ? "LinkStatus.SignedIn" : "LinkStatus.SignedInNoEmail",
  }[linkStatus];

  const isSignedIn = linkStatus === "signedIn";

  // En inloggad användare skickas från /login ändå till startsidan, så där går loggan och
  // krysset direkt dit.
  const leaveCard = () => navigate(isSignedIn ? "/" : "/login");
  const leaveCardTitle = isSignedIn
    ? intl.formatMessage({ id: "LinkStatus.ToStartPage" })
    : "Tillbaka till loginsidan";

  return (
    <div className="app flex-row align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md="8">
            <CardGroup>
              <Card
                style={{ cursor: "pointer", width: "44%" }}
                body
                className="text-white bg-success py-5 d-md-down-none"
              >
                <div onClick={leaveCard} title={leaveCardTitle}>
                  <img
                    style={{ width: "100%" }}
                    src={"img/LearnWareLoggo.png"}
                    className="img-avatar"
                    alt="LearnWARE logga in"
                  />
                </div>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle className="h3" style={{ marginBottom: "0.25rem" }}>
                    <FormattedMessage id={headerId} />
                    <i
                      onClick={leaveCard}
                      title={leaveCardTitle}
                      style={{ cursor: "pointer" }}
                      className="fa fa-close float-end close"
                    />
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <p>
                    <FormattedMessage
                      id={messageId}
                      values={{ email }}
                    />
                  </p>
                  {isSignedIn && (
                    <>
                      <Button color="success" block onClick={signOut}>
                        <FormattedMessage id="LogOut" />
                      </Button>
                      <Button
                        color="secondary"
                        outline
                        block
                        className="mt-2"
                        onClick={() => navigate("/")}
                      >
                        <FormattedMessage id="Cancel" />
                      </Button>
                    </>
                  )}
                  {linkStatus === "expired" && (
                    <Button
                      color="success"
                      block
                      onClick={() =>
                        navigate(requestNewLinkPath, { state: { legacyCheck } })
                      }
                    >
                      <FormattedMessage id="Views.UpdatePassword.RequestNewLink" />
                    </Button>
                  )}
                </CardBody>
              </Card>
            </CardGroup>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default LinkStatusCard;
